<!--
  - Copyright (c) 2023. Haodong JU
  -->

<template>
  <div>
    <div class="d-flex">
      <div />
      <v-spacer />
    </div>

    <ik-data-table
      v-if="!refresh"
      ref="table"
      :custom-on-row-click="editItem"
      entity-name="operationRecords"
      :model="currentModel"
      :required-date-value="$parent.dateRange"
      :use-add-action="false"
      :use-delete-action="false"
      :use-edit-action="false"
      icon="mdi-cash-plus"
      @date-update="it=>$parent.dateRange=it"
    >
      <template #right>
        <v-btn
          color="amber lighten-4 black--text mx-2"
          elevation="0"
          @click="printLog"
        >
          {{ $t('print') }}
        </v-btn>
      </template>
      <template #footer>
        <v-tabs
          v-model="tab"
          background-color="transparent"
          color="black"
          style="background: transparent"
        >
          <v-tab>{{ $t('operateData') }}</v-tab>
          <v-tab>{{ $t('Statistics') }}</v-tab>
          <v-tab>{{ $t('Details') }}</v-tab>
        </v-tabs>
      </template>
      <template #[`item.note`]="{item}">
        <div v-if="!item.note">
          <v-btn
            color="amber lighten-4 black--text"
            elevation="0"
            small
            @click.stop="editItem(item)"
          >
            {{ $t('EditorsNotes') }}
          </v-btn>
        </div>
        <div v-else>
          {{ item.note }}
        </div>
      </template>
    </ik-data-table>

    <v-dialog
      v-model="editDialog"
      max-width="600px"
    >
      <v-card class="pa-8">
        <div class="d-flex align-center">
          <div class="text-h3">
            {{ $t('edit') }}
          </div>
          <v-spacer />
          <div>
            <v-btn
              icon
              @click="editDialog = false"
            >
              <v-icon large>
                mdi-close
              </v-icon>
            </v-btn>
          </div>
        </div>
        <div
          class="d-flex flex-column mt-8"
        >
          <div
            class="text-h4 font-weight-bold"
          >
            {{ $t('attention') }}
          </div>
          <v-text-field
            v-model="note"
            class="mt-2"
            dense
            hide-details
            outlined
            style="width: 100%"
          />
        </div>
        <v-btn
          class="amber lighten-4 mt-8"
          elevation="0"
          outlined
          width="100%"
          @click="save"
        >
          {{ $t('save') }}
        </v-btn>
      </v-card>
    </v-dialog>
  </div>
</template>

<script>
import IkDataTable from '@/plugins/EntityFrameWork/IkDataTable.vue'
import OperationLog from '@/model/dataLayer/api/operationLog/OperationLog'
import { mapMutations } from 'vuex'
import { showSuccessMessage } from '@/model/utils/utils'
import OperationStatisitc, { printOperationLog } from '@/model/dataLayer/api/operationLog/operationStatisitc'
import OperationManage from '@/model/dataLayer/api/operationLog/OperationManage'

export default {
  components: {
    IkDataTable
  },
  data: function () {
    return {
      titleList: [],
      tab: 0,
      note: '',
      selectedItem: null,
      editDialog: false,
      model: OperationLog,
      refresh: false
    }
  },
  computed: {
    currentModel () {
      return this.tab === 0 ? OperationManage : this.tab === 1 ? OperationStatisitc : OperationLog
    }
  },
  watch: {
    '$parent.dateRange': {
      handler: function (val) {

      },
      deep: true,
      immediate: true
    },
    editDialog (val) {
      if (!val) {
        this.note = ''
        this.selectedItem = null
      }
    },
    currentModel () {
      this.refresh = true
      setTimeout(() => {
        this.refresh = false
      }, 50)
    }
  },
  methods: {
    async printLog () {
      try {
        await printOperationLog(this.$parent.dateRange, 1)
        showSuccessMessage(this.$t('print_success'))
      } catch (e) {
        this.showErrorDialog(this.$t('failed_to_print'))
      }
    },
    ...mapMutations(['showErrorDialog']),
    async save () {
      this.selectedItem.note = this.note
      await OperationLog.edit(this.selectedItem)
      this.editDialog = false
      this.$refs.table.reload()
    },
    editItem (item) {
      if (this.tab === 2) {
        if (!item.note) {
          this.selectedItem = item
          this.editDialog = true
        } else {
          this.showErrorDialog(this.$t('PrintHint'))
        }
      }
    }
  }
}
</script>
